import { LocalDate } from '@fcom/core/utils';

export const getFirstDefinedDateOrEmpty = (...dates: string[]): LocalDate | undefined => {
  const definedDate = dates.find((date) => !!date && LocalDate.isLocalDate(date));
  return definedDate ? new LocalDate(definedDate) : undefined;
};
